"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  t = require("./toPropertyKey-ec4a2a72.js"),
  n = require("react"),
  a = require("prop-types"),
  l = require("styled-components"),
  r = require("./grid-965d799c.js"),
  i = require("./box-147a8373.js"),
  d = require("./link-8b1ebef7.js"),
  o = require("./typography-fb2881fe.js"),
  u = require("./foundations/Icon/icons/utility/CaratRight.js.js"),
  c = require("./taggedTemplateLiteral-97b463ad.js"),
  f = require("polished/lib/helpers/rem"),
  s = require("./widowBlock-bd32f3ea.js"),
  g = require("./foundations/Icon/icons/utility/ArrowRight.js.js"),
  m = require("./styles-df7980c2.js");
function p(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var h,
  y,
  b,
  T,
  k,
  x,
  w,
  j,
  v,
  E,
  L,
  C,
  _,
  q = p(n),
  P = p(a),
  H = p(l),
  I = p(f),
  U = H["default"](r.Col)(h || (h = c._taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), I["default"](12)),
  A = H["default"].div(y || (y = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.themeType,
      a = e.backgroundVariant,
      r = e.branding,
      i = e.condensed,
      d = e.fixHeight;
    return l.css(b || (b = c._taggedTemplateLiteral(["\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    height: ", ";\n    overflow: hidden;\n    ", ";\n    ", "\n    :hover {\n      .icon-product-callout-arrow {\n        transition: left 0.2s;\n        left: ", ";\n        margin-right: 0;\n      }\n    }\n  "])), m.getSectionBackgroundColor(a, r, t, n), t.colors.neutral.grayDark20, i && d ? I["default"](90) : "100%", "padding: ".concat(i ? I["default"](24) : I["default"](40), " 0;"), i && "\n      display: flex;\n      align-items: center;\n    ", I["default"](10));
  }),
  B = H["default"](g)(T || (T = c._taggedTemplateLiteral(["\n ", "\n"])), function (e) {
    var t = e.theme,
      n = t.mediumUp();
    return l.css(k || (k = c._taggedTemplateLiteral(["\n      transition: left 0.2s;\n      margin-bottom: ", ";\n      margin-left: ", ";\n      left: 0;\n      position: relative;\n      margin-top: ", ";\n      fill: ", ";\n    "])), I["default"](2), I["default"](10), n ? I["default"](11) : I["default"](7), t.colors.action.lightTheme.linkDefault);
  }),
  V = H["default"](d.LinkComponent)(x || (x = c._taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none;\n  :hover {\n    && {\n      text-decoration: none;\n    }\n  }\n"]))),
  R = H["default"](r.Row)(w || (w = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.condensed;
    return l.css(j || (j = c._taggedTemplateLiteral(["\n    position: relative;\n    padding: 0 ", " 0 ", ";\n    ", "\n  "])), I["default"](24), I["default"](16), t && "display: none;");
  }),
  N = H["default"](r.Row)(v || (v = c._taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-items: flex-start;\n"]))),
  S = H["default"](o.TypographyComponent)(E || (E = c._taggedTemplateLiteral(["\n  padding-bottom: 0;\n  padding-right: ", ";\n"])), I["default"](32)),
  D = H["default"](o.TypographyComponent)(L || (L = c._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.condensed,
      a = e.withHeadingAccent,
      r = t.mediumUp(),
      i = t.largeUp(),
      d = I["default"](23),
      o = "85%",
      u = r ? I["default"](12) : I["default"](8),
      f = "none";
    return i ? (d = I["default"](28), o = "80%") : r && (d = I["default"](25), o = "75%"), n && (u = 0, f = "inline-block", o = "100%"), a && (f = "inline-block"), l.css(C || (C = c._taggedTemplateLiteral(["\n      padding-bottom: ", ";\n      max-width: ", ";\n      :before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: ", ";\n        display: ", ";\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n        ", "\n      }\n    "])), u, o, n ? 0 : I["default"](-3), f, I["default"](5), d, t.colors.gold.gold, n && "\n          bottom: 0;\n          margin-top: auto;\n          margin-bottom: auto;\n        ");
  }),
  F = H["default"](s.WidowBlockComponent)(_ || (_ = c._taggedTemplateLiteral(["\n  display: inline;\n  white-space: nowrap;\n"]))),
  O = function O(t) {
    var n = t.children,
      a = t.condensed,
      l = t.linkId,
      r = t.linkProps,
      i = t.linkUrl;
    return a ? q["default"].createElement(V, e._extends({}, r, {
      linkUrl: i,
      id: l,
      variant: "primaryDeemphasize"
    }), n) : n;
  },
  M = function M(a) {
    var c,
      f,
      s,
      g,
      m = a.ariaLabel,
      p = a.backgroundVariant,
      h = a.branding,
      y = a.cardFootnote,
      b = a.cardHeading,
      T = a.cardId,
      k = a.cardText,
      x = a.className,
      w = a.condensed,
      j = a.config,
      v = a.contentBlock,
      E = a.fixHeight,
      L = a.icon,
      C = a.linkId,
      _ = a.linkProps,
      P = a.linkText,
      H = a.linkUrl,
      V = a.themeType,
      M = a.withHeadingAccent,
      z = (c = n.useContext(l.ThemeContext).mediumUp() ? I["default"](44) : I["default"](33), {
        IconCardMainStyled: {
          height: "".concat(c),
          width: "".concat(c),
          position: "absolute",
          right: I["default"](16),
          top: I["default"](-8)
        }
      });
    return b && (s = (f = "object" === t._typeof(b) ? b.props.children.toString() : b).split(" ").slice(0, -2).join(" "), g = f.split(" ").splice(-2).join(" ")), q["default"].createElement(O, {
      condensed: w,
      linkId: C,
      linkProps: _,
      linkUrl: H
    }, q["default"].createElement(A, {
      id: T,
      backgroundVariant: p,
      branding: h,
      className: x,
      condensed: w,
      fixHeight: E,
      themeType: V
    }, q["default"].createElement(R, null, q["default"].createElement(r.Col, null, q["default"].createElement(N, null, b && q["default"].createElement(D, {
      component: "h3",
      condensed: w,
      themeType: V,
      variant: "h4",
      withHeadingAccent: M
    }, w ? q["default"].createElement(q["default"].Fragment, null, s, " ", q["default"].createElement(F, null, g, " ", q["default"].createElement(B, {
      className: "icon-product-callout-arrow"
    }))) : b), L && !w && function (e, n) {
      if ("object" === t._typeof(e)) return e;
      var a = e;
      return q["default"].createElement(a, {
        style: n.IconCardMainStyled
      });
    }(L, z)), k && !w && q["default"].createElement(S, {
      themeType: V
    }, k), v && !w && q["default"].createElement(q["default"].Fragment, null, v))), P && q["default"].createElement(R, {
      className: "nmx-no-print",
      condensed: w
    }, q["default"].createElement(U, null, q["default"].createElement(d.LinkComponent, e._extends({}, _, {
      id: C,
      ariaLabel: m,
      config: j,
      endAdornment: u,
      endAdornmentStylesReset: !0,
      linkUrl: H,
      themeType: V,
      variant: "buttonLinkTertiary"
    }), P, " "))), y && !w && q["default"].createElement(i.Box, {
      sx: {
        mt: 1
      }
    }, " ", q["default"].createElement(R, null, q["default"].createElement(r.Col, null, q["default"].createElement(o.TypographyComponent, {
      component: "small",
      disableBottomPadding: !0,
      themeType: V
    }, y))))));
  };
M.propTypes = {
  backgroundVariant: P["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: P["default"].oneOf(["nm", "pcg"]),
  cardFootnote: P["default"].string,
  cardHeading: P["default"].oneOfType([P["default"].string, P["default"].object]),
  cardId: P["default"].string.isRequired,
  cardText: P["default"].any,
  className: P["default"].string,
  condensed: P["default"].bool,
  config: P["default"].shape({
    basePath: P["default"].string,
    nmxTemplateVersion: P["default"].string
  }),
  contentBlock: P["default"].any,
  icon: P["default"].any,
  linkId: P["default"].string,
  linkProps: P["default"].shape(d.linkPropTypes),
  linkText: P["default"].string,
  linkUrl: P["default"].string,
  themeType: P["default"].oneOf(["lightTheme", "darkTheme"]),
  withHeadingAccent: P["default"].bool
}, M.defaultProps = {
  backgroundVariant: "lightB",
  branding: "nm",
  condensed: !1,
  config: {
    basePath: "https://www.northwesternmutual.com",
    nmxTemplateVersion: "3.10.11"
  },
  themeType: "lightTheme",
  withHeadingAccent: !1
};
var z = l.withTheme(M);
exports.ProductCard = z;